import deleteItemDynamoDB from '../../api/deleteItemDynamoDB';
import { trainSetsTableName } from '../../api/apiConstants';

const deleteTrainSet = async (
  myTrainSetId: any,
  myToken: any,
  myCustomId: any
) => {
  const data = await deleteItemDynamoDB(
    trainSetsTableName,
    myTrainSetId,
    myToken,
    myCustomId
  );
  if (data.err) {
    return null;
  }
  return data;
};

export default deleteTrainSet;
